package one.healthium.base.sender

import co.touchlab.kermit.Logger
import com.eygraber.uri.Uri
import one.healthium.base.launcher.PlatformLauncher

actual object EmailSender {
    actual fun sendEmail(
        platformLauncher: PlatformLauncher,
        email: String,
        subject: String?
    ) {
        val mailtoUrl = buildString {
            append("mailto:")
            append(email)
            if (!subject.isNullOrEmpty()) {
                append("?subject=${Uri.encode(subject)}")
            }
        }

        try {
            kotlinx.browser.window.location.href = mailtoUrl
        } catch (e: Exception) {
            Logger.e("Failed to send email", e)
        }
    }
}